import type { GameSession } from '@perplexicon/api-client';

export type PlayAgainTarget = 'solo' | 'multiplayer-catalog' | null;

export interface SessionControlState {
  showAbandon: boolean;
  playAgainTarget: PlayAgainTarget;
}

export function sessionControlState(
  session: GameSession,
  selfUserId: string | undefined,
): SessionControlState {
  if (session.status === 'active') {
    return { showAbandon: true, playAgainTarget: null };
  }

  if (session.status !== 'completed' || session.completionReason !== 'normal') {
    return { showAbandon: false, playAgainTarget: null };
  }

  if (session.mode === 'solo') {
    return { showAbandon: false, playAgainTarget: 'solo' };
  }

  if (selfUserId && session.createdBy === selfUserId) {
    return { showAbandon: false, playAgainTarget: 'multiplayer-catalog' };
  }

  return { showAbandon: false, playAgainTarget: null };
}
